<template>
  <svg fill="none" height="20" viewBox="0 0 13 20" width="13" xmlns="http://www.w3.org/2000/svg">
    <circle class="v-icon-fill-color" cx="3" cy="3" r="2.5" />
    <circle class="v-icon-fill-color" cx="10" cy="3" r="2.5" />
    <circle class="v-icon-fill-color" cx="3" cy="10" r="2.5" />
    <circle class="v-icon-fill-color" cx="10" cy="10" r="2.5" />
    <circle class="v-icon-fill-color" cx="3" cy="17" r="2.5" />
    <circle class="v-icon-fill-color" cx="10" cy="17" r="2.5" />
  </svg>
</template>
